








































import Vue from "vue";
import { PPOrder } from "@/picking-portal/models/PPOrder";
import { orderService } from "@/picking-portal/services/PPOrderService";
import PPCollectOrderItem from "@/picking-portal/components/PPCollectOrderItem.vue";
import { PPOrderStatus } from "@/picking-portal/enums/PPOrderStatus";
import { ElementColors } from "@/common/theme/ElementColors";
import PPCustomerInfoComponent from "@/picking-portal/components/PPCustomerInfoComponent.vue";
import PPOrderStatusChip from "@/picking-portal/components/PPOrderStatusChip.vue";
import { PPClickAndCollectStatus } from "@/picking-portal/enums/PPClickAndCollectStatus";
import { Paths, RouteInfoMap } from "@/common/enums/RouterPaths";
import { storeService } from "@/common/services/StoreService";
import { DateTime } from "luxon";

export default Vue.extend({
  name: "PPCollectOrder",
  components: {
    PPOrderStatusChip,
    PPCustomerInfoComponent,
    PPCollectOrderItem,
  },
  props: {
    transactionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true as boolean,
      order: {} as PPOrder,
      orderFetched: false as boolean,
      Colors: ElementColors,
      PPOrderStatus,
      PPClickAndCollectStatus,
      storeService,
    };
  },
  computed: {
    breadcrumbs(): Array<Record<string, string | boolean>> {
      return this.$route?.meta?.breadCrumb({
        storeId: storeService.selectedStore,
        date: DateTime.now().toSQLDate(),
        from: this.order?.booking?.start,
        to: this.order?.booking?.end,
      });
    },
    currentStore: function (): string {
      return this.storeService.selectedStore;
    },
  },
  watch: {
    currentStore: function (): void {
      this.changeStore();
    },
  },
  async mounted() {
    this.order = await orderService.getFulfillment(this.transactionId);
    this.orderFetched = true;
    this.isLoading = false;
  },
  methods: {
    async collectOrder(): Promise<void> {
      await orderService.setFulfillmentCollected(this.transactionId);
      this.order = await orderService.getFulfillment(this.transactionId);
    },
    async changeStore(): Promise<void> {
      await this.$router
        .push({
          name: RouteInfoMap.get(Paths.ClickAndCollect)?.name,
          query: {
            storeId: storeService.selectedStore.toString(),
            date: DateTime.now().toFormat("yyyy-MM-dd"),
          },
        })
        .catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
    },
  },
});
